import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import CompanionSlotMachine from './CompanionSlotMachine';

interface CompanionSlotMachineModalProps {
  isOpen: boolean;
  onClose: () => void;
  isFreePremiumSpin?: boolean;
  onFreePremiumSpinComplete?: () => void;
}

const CompanionSlotMachineModal: React.FC<CompanionSlotMachineModalProps> = ({
  isOpen,
  onClose,
  isFreePremiumSpin = false,
  onFreePremiumSpinComplete
}) => {
  return (
    <AnimatePresence key="slot-machine-modal">
      {isOpen && (
        <motion.div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl p-1 sm:p-2 md:p-4 max-w-5xl w-full max-h-[99vh] sm:max-h-[98vh] md:max-h-[95vh] overflow-hidden flex flex-col shadow-2xl border border-gray-600/50 modal-content"
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 20 }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header - Kompakter auf Mobile */}
            <div className="flex justify-between items-center mb-1 sm:mb-2 md:mb-4 flex-shrink-0 p-1 sm:p-2">
              <h3 className="text-base sm:text-lg md:text-2xl font-bold text-white flex items-center gap-1 sm:gap-2 md:gap-3">
                <span className="text-lg sm:text-xl md:text-3xl">🎰</span>
                <span className="hidden md:inline">Begleiter-Glücksautomat</span>
                <span className="hidden sm:inline md:hidden">Glücksautomat</span>
                <span className="sm:hidden">Slot</span>
              </h3>
              <button
                onClick={onClose}
                className="text-white hover:text-red-300 hover:bg-red-500/20 text-lg sm:text-xl md:text-3xl font-bold px-1 sm:px-2 md:px-3 py-1 rounded-full transition-all duration-200 transform hover:scale-110 active:scale-95 touch-manipulation min-w-[28px] sm:min-w-[32px] md:min-w-[40px] min-h-[28px] sm:min-h-[32px] md:min-h-[40px] flex items-center justify-center"
                title="Schließen"
              >
                ×
              </button>
            </div>

            {/* Slot Machine Content - Flex-1 für verfügbaren Platz */}
            <div className="bg-gradient-to-br from-gray-700 to-gray-800 rounded-lg p-1 sm:p-2 md:p-4 flex-1 overflow-hidden">
              <div className="h-full overflow-hidden">
                <CompanionSlotMachine
                  isFreePremiumSpin={isFreePremiumSpin}
                  onFreePremiumSpinComplete={onFreePremiumSpinComplete}
                />
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CompanionSlotMachineModal; 